/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineNotificationService() {
        let notificationService = {};
        notificationService.getMessageTypes = function (){
            return axios.get("/api/NotificationService/GetMessageTypes");
        };
        return notificationService;
    }
    //define globally if it doesn't already exist
    if (typeof (notificationService) === "undefined") {
        window.notificationService = defineNotificationService();
    } else {
        console.log("notificationService already defined.");
    }
})(window);